// The style functions here are counted for coverage purposes, but there's
// really no point in testing them individually, so ignoring the file.
/* istanbul ignore file */
import { css } from "styled-components";
import { media } from "../media";

const heading = css`
  font-family: ${({ theme }) => theme.fonts.bold}, Lato, Sans-Serif;
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.2;
`;
const title = css`
  font-family: ${({ theme }) => theme.fonts.bold}, Lato, Sans-Serif;
  font-weight: bold;
  line-height: 1.2;

  font-size: 2rem;
  @media ${media.tablet} {
    font-size: 1.5rem;
  }
  @media ${media.mobile} {
    font-size: 1.25rem;
  }
`;
const subtitle = css`
  font-family: ${({ theme }) => theme.fonts.bold}, Lato, Sans-Serif;
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.2;
`;
const bodyBold = css`
  font-family: ${({ theme }) => theme.fonts.bold}, Lato, Sans-Serif;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.5;
`;
const body = css`
  font-family: ${({ theme }) => theme.fonts.regular}, Lato, Sans-Serif;
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.5;
`;
const smallBold = css`
  font-family: ${({ theme }) => theme.fonts.bold}, Lato, Sans-Serif;
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.5;
`;
const small = css`
  font-family: ${({ theme }) => theme.fonts.regular}, Lato, Sans-Serif;
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.5;
`;

// For text that should appear with Appointedd branding, regardless of the theme
// eg the "Powered by Appointedd" text in the footer.
const appointedd = css`
  /* devanagari */
  @font-face {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 300;
    src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8Z11lFd2JQEl8qw.woff2)
      format("woff2");
    unicode-range: U+0900-097F, U+1CD0-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC,
      U+A830-A839, U+A8E0-A8FF;
  }
  /* latin-ext */
  @font-face {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 300;
    src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8Z1JlFd2JQEl8qw.woff2)
      format("woff2");
    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,
      U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 300;
    src: url(https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDz8Z1xlFd2JQEk.woff2)
      format("woff2");
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122,
      U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  font-family: Poppins, sans-serif;
  font-size: 0.75rem;
  font-weight: 300;
  line-height: 1.125;
`;

/* eslint-disable sort-keys */
export const typography = {
  heading,
  title,
  subtitle,
  bodyBold,
  body,
  smallBold,
  small,
  appointedd,
} as const;
/* eslint-enable sort-keys */
